"use client";
import { Box, Typography } from "@mui/material";
import ThumbnailUploader, {
	ThumbnailUploaderProps,
} from "@onair/ui/thumbnail-uploader";
import { Field } from "@onair/minimal-ui/hook-form";
import { UseFormReturn } from "react-hook-form";
import { SmallDotSvg } from "@onair/ui/svg/small-dot";
import { CreateSurveyFormFields } from "../survey-form.schema";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
} from "../custom-accordion";
import { memo, useEffect, useState } from "react";
import { useWatch } from "react-hook-form";
// import { useManageSurveyStore } from "../../../store/manage-survey-provider";
import { cn } from "@onair/utils/cn";

interface SurveyInfomationFormProps {
	methods: UseFormReturn<CreateSurveyFormFields>;
}
const SurveyInfomationForm: React.FC<SurveyInfomationFormProps> = ({
	methods,
}) => {
	// const setSurveyInfo = useManageSurveyStore((state) => state.setSurveyInfo);
	const { setValue, formState, setError, control } = methods;

	const watchTitle = useWatch({ control, name: "title" });
	const watchDescription = useWatch({ control, name: "description" });
	const watchBanner = useWatch({ control, name: "banner" });
	const [expanded, setExpanded] = useState(true);

	const handleSelectThumbnail: ThumbnailUploaderProps["onSelect"] = (
		banner,
		resource,
	) => {
		if (!resource.fileType?.includes("image/")) {
			setError("banner", { message: "Banner không hợp lệ." });
			return;
		}
		setValue("banner", banner, { shouldValidate: true });
	};
	const handleRemoveThumbnail = () => {
		setValue("banner", "");
	};

	// useEffect(() => {
	// 	setSurveyInfo({
	// 		title: watchTitle,
	// 		description: watchDescription,
	// 		banner: watchBanner,
	// 	});
	// }, [watchTitle, watchDescription, watchBanner]);
	return (
		<Box
			component="div"
			className={cn("bg-white rounded-xl overflow-hidden border", {
				"border-red-500":
					!!formState?.errors?.banner || formState?.errors?.title,
			})}
		>
			<Accordion expanded={expanded}>
				<AccordionSummary onToggleExpand={() => setExpanded((prev) => !prev)}>
					<Box component="div" className="flex items-center justify-between">
						<h2 className="text-2xl font-semibold">Tiêu đề</h2>
					</Box>
				</AccordionSummary>
				<AccordionDetails>
					<ThumbnailUploader
						value={watchBanner}
						onSelect={handleSelectThumbnail}
						onRemove={handleRemoveThumbnail}
						title="Banner khảo sát"
						error={formState?.errors?.banner?.message}
						note={
							<>
								<Typography variant="caption" color="text.secondary">
									Kích thước chuẩn: <b>840x360</b>
								</Typography>
								<SmallDotSvg />
								<Typography variant="caption" color="text.secondary">
									File <b>jpg, png</b>
								</Typography>
							</>
						}
						className="max-w-[340px]"
					/>
					<div className="h-6"></div>
					<Box component="div">
						<Typography variant="subtitle2" gutterBottom>
							Tiêu đề <span className="text-[#F04438]">*</span>
						</Typography>
						<Field.Text
							name="title"
							label="Nhập tiêu đề khảo sát"
							value={watchTitle}
							helperText={`Tối đa ${watchTitle?.length || 0}/200 ký tự`}
						/>
					</Box>
					<div className="h-6"></div>
					<Box component="div">
						<Typography variant="subtitle2" gutterBottom>
							Mô tả
						</Typography>
						<Field.Editor
							name="description"
							resourceItem={true}
							placeholder="Nhập nội dung mô tả"
							value={watchDescription}
						/>
					</Box>
				</AccordionDetails>
			</Accordion>
		</Box>
	);
};
export default memo(SurveyInfomationForm);
